// Team.js
import React from 'react';
import AnimateOnScroll from './AnimateOnScroll';
import './Team.css';
import tiagoImage from '../assets/tiago.png';
import vitorImage from '../assets/vitor.jpg';
import danuzaImage from '../assets/danuza.jpg';

const Team = () => {
  const teamMembers = [
    {
      name: "Tiago Machado Jardim",
      role: "Chief Executive Officer",
      area: "Desenvolvimento de Sistemas",
      expertise: "Engenharia de Software, Metodologias Ágeis e Gestão Empresarial",
      image: tiagoImage,
      social: {
        linkedin: "https://linkedin.com/in/tiagojardim-tech",
        instagram: "https://instagram.com/tiago.machado.jardim",
        whatsapp: "https://wa.me/5553997054143",
        email: "tiago@bientech.com.br"
      }
    },
    {
      name: "Vitor da Silva Ferreira",
      role: "Chief Technology Officer",
      area: "Desenvolvimento de Jogos",
      expertise: "Game Design, Tecnologias Interativas e Gamificação em Saúde",
      image: vitorImage,
      social: {
        linkedin: "https://linkedin.com/in/vitor-ferreira-216958329",
        whatsapp: "https://wa.me/5553999991299",
        email: "vitor@bientech.com.br"
      }
    },
    {
      name: "Danuza Teixeira Corrêa",
      role: "Chief Health Officer",
      area: "Área da Saúde",
      expertise: "Fisioterapia Cardiorrespiratória, Gestão Clínica e Relacionamento com Clientes",
      image: danuzaImage,
      social: {
        linkedin: "https://linkedin.com/in/danuza-teixeira-corrêa-621929264",
        whatsapp: "https://wa.me/5553999096040",
        email: "danuza@bientech.com.br"
      }
    }
  ];

  return (
    <section className="team" id="team">
      <AnimateOnScroll variant="fadeUp">
        <div className="section-header">
          <h2>Nossa Equipe</h2>
          <p className="section-subtitle">Conheça os fundadores da Bientech</p>
        </div>
      </AnimateOnScroll>
      <AnimateOnScroll variant="fadeUp" delay={150}>
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <div className="card-background"></div>
            <div className="member-photo">
              <img src={member.image} alt={member.name} />
              <div className="photo-overlay"></div>
            </div>
            <div className="member-content">
              <h3 className="member-name">{member.name}</h3>
              <span className="member-role">{member.role}</span>
              <div className="member-details">
                <div className="detail-item">
                  <span className="detail-label">Área:</span>
                  <span className="detail-value">{member.area}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Especialização:</span>
                  <span className="detail-value">{member.expertise}</span>
                </div>
              </div>
              <div className="social-links">
                {member.social.linkedin && (
                  <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" className="social-link linkedin-link" aria-label="LinkedIn">
                    <i className="fab fa-linkedin"></i>
                  </a>
                )}
                {member.social.email && (
                  <a href={`mailto:${member.social.email}`} className="social-link email-link" aria-label="Email">
                    <i className="fas fa-envelope"></i>
                  </a>
                )}
                {member.social.whatsapp && (
                  <a href={member.social.whatsapp} target="_blank" rel="noopener noreferrer" className="social-link whatsapp-link" aria-label="WhatsApp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                )}
                {member.social.instagram && (
                  <a href={member.social.instagram} target="_blank" rel="noopener noreferrer" className="social-link instagram-link" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      </AnimateOnScroll>
    </section>
  );
};

export default Team;
